import { css } from 'styled-components';

export const DEFAULT_STYLING = css`
    transform: scale(1.2) rotate(45deg);
    width: 6px;
    height: 12px;
    left: 9px;
    top: 4px;
`;

export const SMALL_SIZE_STYLING = css`
    transform: scale(1.2) rotate(45deg);
    width: 4px;
    height: 10px;
    left: 7px;
    top: 3px;
`;

export const INDETERMINATE_DEFAULT_STYLING = css`
    transform: scale(1.2) rotate(180deg);
    width: 12px;
    height: 2px;
    left: 6px;
    top: 11px;
`;

export const INDETERMINATE_SMALL_SIZE_STYLING = css`
    transform: scale(1.2) rotate(180deg);
    width: 8px;
    height: 2px;
    left: 5px;
    top: 8px;
`;
